<!-- review-and-release.component.html -->
<div class="rr">
	<!-- Header -->
	<div class="p-hdr">
		<div>
			<h1>Review &amp; Release</h1>
			<p>AI triages every lead — you only touch the flagged ones, and set billing + release in one step.</p>
		</div>
		<div class="rr-hdr-right">
			<!-- <span class="rr-autoclear"></span>
			<div class="rr-roleswitch" title="Test-mode: toggle the AI decision bands">
				<span class="rr-roleswitch-lbl">AI bands</span>
				<button class="rr-role-btn">Auto-approve</button>
				<button class="rr-role-btn">Auto-deny</button>
				<button class="rr-role-btn"></button>
			</div> -->
			<!-- <div class="rr-roleswitch" title="Test-mode: preview the queue as each role">
				<span class="rr-roleswitch-lbl">Preview as</span>
				<ng-container *ngFor="let r of roles; trackBy: trackByValue">
					<button class="rr-role-btn" [class.active]="perms.adminRole() === r" (click)="setRole(r)">{{ ROLE_LABELS[r] }}</button>
				</ng-container>
			</div> -->
		</div>
	</div>

	<!-- Filter tabs -->
	<div class="rr-tabs">
		<button class="rr-tab" [class.active]="tab() === 'review'" (click)="setTab('review')">
			Needs review <span class="rr-tab-count">{{ counts().review }}</span>
		</button>

		<!-- <button *ngIf="caps().releaseBilling" class="rr-tab" [class.active]="tab() === 'billing'" (click)="setTab('billing')">
			Billing pending <span class="rr-tab-count">{{ counts().billing }}</span>
		</button> -->

		<!-- <button class="rr-tab" [class.active]="tab() === 'cleared'" (click)="setTab('cleared')">
			AI auto-cleared <span class="rr-tab-count">{{ counts().cleared }}</span>
		</button> -->

		<!-- <button class="rr-tab" [class.active]="tab() === 'released'" (click)="setTab('released')">
			Released <span class="rr-tab-count">{{ counts().released }}</span>
		</button> -->

		<button class="rr-tab" [class.active]="tab() === 'fix'" (click)="setTab('fix')">
			Fix <span class="rr-tab-count">{{ counts().fix }}</span>
		</button>

		<button class="rr-tab" [class.active]="tab() === 'approved'" (click)="setTab('approved')">
			Approved <span class="rr-tab-count">{{ counts().approved }}</span>
		</button>

		<button class="rr-tab" [class.active]="tab() === 'overproduced'" (click)="setTab('overproduced')">
			Overproduced <span class="rr-tab-count">{{ counts().overproduced }}</span>
		</button>

		<button class="rr-tab" [class.active]="tab() === 'denied'" (click)="setTab('denied')">
			Denied <span class="rr-tab-count">{{ counts().denied }}</span>
		</button>
	</div>

	<div class="rr-toolbar d-flex align-items-center gap-2">
		<div class="rr-search-box">
			<input type="text" [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()" placeholder="Search this list" class="rr-search-input" />
		</div>
		<div class="rr-daterange-by" *ngIf="tab() !== 'review'">
			<select class="rr-select" [(ngModel)]="selectedOptions.qcControl.dateBy" (change)="selectSearch()">
				<option value="date_generated">Appt Date</option>
				<option value="lead_creation">Creation Date</option>
			</select>
		</div>
		<div class="rr-daterange" *ngIf="tab() !== 'review'">
			<app-form-range-date [(ngModel)]="dateRange_" (OnSelected)="dateSelected($event)" [position]="'right'"></app-form-range-date>
		</div>

		<app-new-column-selector class="ms-auto" [columns]="columns"></app-new-column-selector>
	</div>

	<!-- Queue table -->
	<div class="p-card">
		<div class="p-card-body">
			<table class="p-table rr-table">
				<thead>
					<tr>
						<!-- <th>AI</th> -->
						<th *ngIf="isColumnVisible('id')">Id</th>
						<th *ngIf="isColumnVisible('prospect')" class="rr-col-prospect">Prospect</th>
						<th *ngIf="isColumnVisible('campaign')">Campaign</th>
						<th *ngIf="isColumnVisible('creation_date')" class="text-center">Creation Date</th>
						<th *ngIf="isColumnVisible('appointment')">Appointment</th>
						<th *ngIf="isColumnVisible('phone')">Phone</th>
						<!-- <th *ngIf="isColumnVisible('warmcall')">Warm-call</th> -->
						<th *ngIf="isColumnVisible('status')">Status</th>
						<th class="text-center" *ngIf="isColumnVisible('difficult')">Difficulty</th>
						<th class="text-center" *ngIf="isColumnVisible('billed')">Billed</th>

						<th *ngIf="isColumnVisible('change_date')">Time in status</th>

						<th *ngIf="isColumnVisible('free_type')">Free Type</th>
						<th *ngIf="isColumnVisible('confirmation')">Confirmation</th>

						<ng-container *ngFor="let col of extraColumns">
							<th *ngIf="isColumnVisible(col.prop)" [class.text-center]="centeredColumns.includes(col.prop)">{{ col.name }}</th>
						</ng-container>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngIf="filteredLeads.length; else emptyRow">
						<tr *ngFor="let lead of filteredLeads; trackBy: trackByLeadId">
							<!-- <td>
								<svg class="rr-ring" viewBox="0 0 40 40" width="38" height="38">
									<circle cx="20" cy="20" r="16" fill="none" stroke="#E2E8F0" stroke-width="4" />
									<circle cx="20" cy="20" r="16" fill="none" [attr.stroke]="band(lead.ai.score).color" stroke-width="4" stroke-linecap="round" [attr.stroke-dasharray]="ringDash(lead.ai.score)" transform="rotate(-90 20 20)" />
									<text x="20" y="24" text-anchor="middle" class="rr-ring-num" [attr.fill]="band(lead.ai.score).color">{{ lead.ai.score }}</text>
								</svg>
							</td> -->
							<td *ngIf="isColumnVisible('id')">
								<span class="rr-link" (click)="openLead(lead)">{{ lead.id }}</span>
							</td>
							<td *ngIf="isColumnVisible('prospect')" class="rr-col-prospect">
								<div class="rr-name">{{ lead.first_name }} {{ lead.last_name }}</div>
								<div class="rr-sub">{{ lead.prospect_company }}</div>
							</td>
							<td *ngIf="isColumnVisible('campaign')" class="rr-col-campaign">{{ lead.campaign_name }}</td>
							<td *ngIf="isColumnVisible('creation_date')" class="text-center">
								<span class="rr-num">{{ lead.lead_creation | utcToLocal: "mediumDate" }}</span>
							</td>
							<td *ngIf="isColumnVisible('appointment')">
								<div class="rr-appt-cell">
									<span class="rr-num">{{ lead.date_generated | utcToLocal }}</span>
									<!-- <pre style="font-size:9px">{{ lead.meet_type }} | {{ getMeetTypeName(lead.meet_type) }}</pre> -->
									<div class="rr-sub rr-appt-type" [ngClass]="getMeetTypeClass(lead.meet_type)">
										<i [ngClass]="getMeetTypeIcon(lead.meet_type)"></i>
										{{ apptTypeMap[lead.meet_type] || "-" }}
									</div>
								</div>
							</td>
							<td *ngIf="isColumnVisible('phone')">
								<a [href]="'tel:' + lead.primary_phone" class="rr-num">
									{{ lead.primary_phone | phone }}
								</a>
							</td>
							<!-- <td *ngIf="isColumnVisible('warmcall')" [ngSwitch]="lead.apptConfirmed">
								<span *ngSwitchCase="'confirmed'" class="pill pg">✓ Confirmed</span>
								<span *ngSwitchCase="'failed'" class="pill pr">✕ Failed</span>
								<span *ngSwitchDefault class="pill py">⋯ Pending</span>
							</td> -->
							<td *ngIf="isColumnVisible('status')" [ngSwitch]="lead.lead_status" class="text-center">
								<span *ngSwitchCase="'Unreviewed'" class="pill pb">Unreviewed</span>
								<span *ngSwitchCase="'Approved'" class="pill pg">Approved</span>
								<span *ngSwitchCase="'Fix'" class="pill py">Fix</span>
								<span *ngSwitchCase="'Denied'" class="pill pr">Denied</span>
								<span *ngSwitchCase="'Replace'" class="pill pu">Replace</span>
								<span *ngSwitchCase="'Pending Replacement'" class="pill pul">Pending Replacement</span>
								<span *ngSwitchCase="'Reschedule'" class="pill pgd">Reschedule</span>
								<span *ngSwitchCase="'Pending Reschedule'" class="pill pgl">Pending Reschedule</span>
								<span *ngSwitchDefault class="pill">{{ lead.lead_status }}</span>
							</td>

							<td class="text-center" *ngIf="isColumnVisible('difficult')" [innerHTML]="lead.difficult | nullToDash"></td>

							<td class="text-center" *ngIf="isColumnVisible('billed')" [innerHTML]="lead.payed | nullToDash"></td>

							<td *ngIf="isColumnVisible('change_date')">{{ lead.change_date | dateAgo }}</td>

							<td class="text-center" *ngIf="isColumnVisible('free_type')" [ngSwitch]="lead.free_type | nullToDash">
								<span *ngSwitchCase="'Reserve'" class="pill pt">Reserve</span>
								<span *ngSwitchCase="'Hourly'" class="pill py">Hourly</span>
								<span *ngSwitchCase="'Promo'" class="pill pg">Promo</span>
								<span class="text-center" *ngSwitchDefault>{{ lead.free_type | nullToDash }}</span>
							</td>
							<td class="text-center" *ngIf="isColumnVisible('confirmation')" [ngSwitch]="lead.confirmation | nullToDash">
								<span *ngSwitchCase="'CONFIRMED'" class="pill pg">Confirmed</span>
								<span *ngSwitchDefault class="pill pr">Not confirmed</span>
							</td>

								<ng-container *ngFor="let col of extraColumns">
									<td *ngIf="isColumnVisible(col.prop)" [class.text-center]="centeredColumns.includes(col.prop)">
										<ng-container [ngSwitch]="col.prop">
											<span *ngSwitchCase="'replaced_by'" class="rr-link" (click)="openLeadById(getReplacedById(lead.replaced_by))">
												{{ lead.replaced_by | nullToDash }}
											</span>
											<span *ngSwitchCase="'replace_for'" class="rr-link" (click)="openLeadById(lead.replace_for)">
												{{ lead.replace_for | nullToDash }}
											</span>
											<ng-container *ngSwitchCase="'difficult'">
												<i *ngIf="lead.difficult && lead.difficult.toLowerCase() !== 'null'; else noDifficulty" class="ri-flag-2-fill" [ngClass]="getDifficultyIconClass(lead.difficult)" aria-hidden="true"></i>
												<ng-template #noDifficulty>{{ lead.difficult | nullToDash }}</ng-template>
											</ng-container>
											<ng-container *ngSwitchDefault>{{ lead[col.prop] | nullToDash }}</ng-container>
										</ng-container>
									</td>
								</ng-container>
								<!-- <td [ngSwitch]="lead.lead_status">
								<ng-container *ngSwitchCase="'review'">
									<span class="pill py">Needs review</span>
									<span *ngIf="recommendsDeny(lead.id)" class="pill pr rr-rec" [title]="recReason(lead.id)">🤖 Recommend deny</span>
								</ng-container>
								<span *ngSwitchCase="'billing'" class="pill pt">Billing pending</span>
								<span *ngSwitchCase="'cleared'" class="pill pg">⚡ AI auto-cleared</span>
								<span *ngSwitchCase="'released'" class="pill pg">Delivered</span>
								<span *ngSwitchCase="'denied'" class="pill pr">Denied</span>
								<span *ngSwitchCase="'fix'" class="pill py" [title]="lead.fixReason">↩ Fix — with caller</span>
								<span *ngSwitchCase="'overproduced'" class="pill pt">Overproduced</span>
							</td> -->
								<!-- <td>
								<span>{{ lead.lead_status }}</span>
							</td> -->


							<td class="rr-action" [ngSwitch]="lead.stage">
								<button *ngSwitchCase="'review'" class="btn btn-p btn-sm" (click)="open(lead.id)">Review</button>

								<!-- <ng-container *ngSwitchCase="'billing'">
									<button *ngIf="caps().releaseBilling; else awaitingSuper" class="btn btn-p btn-sm" (click)="open(lead.id)">Set billing &amp; release</button>
									<ng-template #awaitingSuper><span class="rr-muted">Awaiting Super Admin</span></ng-template>
								</ng-container>
								<span *ngSwitchCase="'cleared'" class="rr-muted">⚡ Auto-cleared (billable)</span>
								<span *ngSwitchCase="'released'" class="rr-muted">Delivered · {{ lead.billingDisposition }}</span>
								<button *ngSwitchCase="'denied'" class="btn btn-o btn-sm" (click)="reopen(lead.id)">↩ Reopen</button>
								<button *ngSwitchCase="'fix'" class="btn btn-o btn-sm" (click)="reopen(lead.id)">↩ Back to review</button>
								<span *ngSwitchCase="'overproduced'" class="rr-muted">beyond weekly order</span> -->
							</td>
						</tr>
					</ng-container>
					<ng-template #emptyRow>
						<tr>
							<td [attr.colspan]="visibleColumnsCount" class="rr-empty">No records found.</td>
						</tr>
					</ng-template>
				</tbody>
			</table>
		</div>
	</div>

	<ng-container *ngIf="selectedLead as lead">
		<div class="rr-drawer-overlay" (click)="close()"></div>
		<aside class="rr-drawer">
			<div class="rr-drawer-hdr">
				<div>
					<div class="rr-drawer-name">{{ lead.first_name }} {{ lead.last_name }}</div>
					<div class="rr-sub">{{ lead.prospect_company }} · #{{ lead.id }}</div>
				</div>
				<button class="rr-drawer-close" (click)="close()" title="Close">✕</button>
			</div>

			<div class="rr-drawer-body">
				<!-- <div class="rr-panel rr-ai">
					<div class="rr-ai-head">
						<svg class="rr-ring rr-ring-lg" viewBox="0 0 40 40" width="58" height="58">
							<circle cx="20" cy="20" r="16" fill="none" stroke="#E2E8F0" stroke-width="4" />
							<circle cx="20" cy="20" r="16" fill="none" [attr.stroke]="band(aiTriage.score).color" stroke-width="4" stroke-linecap="round" [attr.stroke-dasharray]="ringDash(aiTriage.score)" transform="rotate(-90 20 20)" />
							<text x="20" y="24" text-anchor="middle" class="rr-ring-num" [attr.fill]="band(aiTriage.score).color">{{ aiTriage.score }}</text>
						</svg>
						<div>
							<div class="rr-panel-title">AI QC triage</div>
							<div class="rr-verdict" [style.color]="band(aiTriage.score).color">{{ aiTriage.verdict }} — confidence {{ aiTriage.score }}/100</div>
						</div>
					</div>
					<div class="rr-reasons">
						<div class="rr-reason" *ngFor="let r of aiTriage.reasons; trackBy: trackByReasonText"><span class="rr-dot" [style.background]="r.positive ? '#16A34A' : '#D97706'"></span>{{ r.text }}</div>
					</div>
					<div class="rr-flags" *ngIf="aiTriage.flags.length">
						<span class="rr-flag" *ngFor="let f of aiTriage.flags; trackBy: trackByValue">⚑ {{ f }}</span>
					</div>
				</div> -->
				<div class="rr-grid">
					<div>
						<div class="rr-k">Campaign</div>
						<div class="rr-v">{{ lead.campaign_name }}</div>
					</div>
					<div>
						<div class="rr-k">Appointment</div>
						<div class="rr-v">{{ lead.date_generated | utcToLocal }}</div>
					</div>
					<div>
						<div class="rr-k">Meeting type</div>
						<div class="rr-v">{{ apptTypeMap[lead.meet_type] || "-" }}</div>
					</div>
					<div>
						<div class="rr-k">Phone</div>
						<div class="rr-v">
							<a [href]="'tel:' + lead.primary_phone" class="rr-link">{{ lead.primary_phone | phone }}</a>
						</div>
					</div>
					<div>
						<div class="rr-k">Status</div>
						<div class="rr-v">{{ lead.replacement_status | nullToDash }}</div>
					</div>
					<div>
						<div class="rr-k">Email</div>
						<div class="rr-v">{{ lead.primary_email | nullToDash }}</div>
					</div>
				</div>

				<div class="rr-grid" *ngIf="lead.free_type || lead.replaced_by || lead.replace_for || lead.difficult || lead.calificado || lead.confirmation">
					<div *ngIf="lead.free_type">
						<div class="rr-k">Free Lead</div>
						<div class="rr-v" [ngSwitch]="lead.free_type">
							<span *ngSwitchCase="'Reserve'" class="pill pt">Reserve</span>
							<span *ngSwitchCase="'Hourly'" class="pill py">Hourly</span>
							<span *ngSwitchCase="'Promo'" class="pill pg">Promo</span>
							<span *ngSwitchDefault>{{ lead.free_type }}</span>
						</div>
					</div>

					<div *ngIf="lead.replaced_by">
						<div class="rr-k">Replaced By</div>
						<div class="rr-v">{{ lead.replaced_by }}</div>
					</div>

					<div *ngIf="lead.replace_for">
						<div class="rr-k">Replace For</div>
						<div class="rr-v">{{ lead.replace_for }}</div>
					</div>

					<div *ngIf="lead.difficult">
						<div class="rr-k">Difficulty</div>
						<div class="rr-v" [innerHTML]="lead.difficult | nullToDash"></div>
					</div>

					<div *ngIf="lead.calificado">
						<div class="rr-k">Qualified</div>
						<div class="rr-v">
							<span class="pill" [ngClass]="lead.calificado === 'GOOD' ? 'pg' : 'pr'">{{ lead.calificado }}</span>
						</div>
					</div>

					<div *ngIf="lead.confirmation">
						<div class="rr-k">Confirmation</div>
						<div class="rr-v">
							<span class="pill pg">{{ lead.confirmation }}</span>
						</div>
						<div *ngIf="lead.confirmation_date" class="rr-sub">{{ lead.confirmation_date | utcToLocal }}</div>
					</div>
				</div>

				<div class="rr-notes" *ngIf="lead.notes">
					<div class="rr-k">Caller notes</div>
					<div class="rr-v">{{ lead.notes }}</div>
				</div>

				<div class="rr-billing">
					<div class="rr-k">Billing disposition</div>
					<select class="rr-select" [disabled]="!caps().releaseBilling" [(ngModel)]="selectedDisposition">
						<option value="" disabled>Select disposition…</option>
						<option *ngFor="let d of dispositions; trackBy: trackByValue" [value]="d" [disabled]="d === 'reserve' && reserveDisabled()">{{ dispositionLabels[d] }}{{ d === "reserve" && reserveDisabled() ? " — exhausted" : "" }}</option>
					</select>
					<div class="rr-lock" *ngIf="!caps().releaseBilling">🔒 Your role ({{ ROLE_LABELS[perms.adminRole()] }}) can pass QC but not set billing. Releasing is a Super Admin action.</div>
				</div>

				<!-- <div class="rr-fix">
					<div class="rr-k">Fix reason <span class="rr-fix-opt">(if sending back to caller)</span></div>
					<input type="text" class="rr-fixinput" [(ngModel)]="fixReason" placeholder="What the caller needs to correct…" />
				</div> -->
			</div>

			<div class="rr-actionbar">
				<button class="btn btn-p" [disabled]="!selectedDisposition" (click)="onApproveClick()">
					{{ selectedDisposition === "charge" ? "Approve" : "Approve and Release" }}
				</button>
				<button class="btn btn-o" (click)="sendToFix()">Send to Fix</button>
				<button class="btn btn-o rr-deny" (click)="denyLead()">Deny</button>
			</div>
		</aside>
	</ng-container>

	<!-- Recent activity -->
	<!-- <div class="p-card rr-activity" *ngIf="activity.entries().length">
		<div class="p-card-hdr">
			<div class="p-card-title">Recent activity</div>
			<span class="rr-muted">auditable · who / what / when</span>
		</div>
		<div class="p-card-body">
			<div class="rr-act-row" *ngFor="let e of activity.entries().slice(0, 6); trackBy: trackByActivityId">
				<span class="rr-act-src" [class.ai]="e.source === 'ai'" [class.vera]="e.source === 'vera'">{{ e.source === "ai" ? "AI" : e.source === "vera" ? "VERA" : e.source === "system" ? "SYS" : "YOU" }}</span>
				<span class="rr-act-time">{{ e.ts }}</span>
				<span class="rr-act-body">
					<strong>{{ e.actor }}</strong> {{ e.action }} <strong>{{ e.target }}</strong>
					<span class="rr-muted" *ngIf="e.detail"> — {{ e.detail }}</span>
				</span>
			</div>
		</div>
	</div>
</div> -->

	<!-- Review drawer -->
	<!-- <ng-container *ngIf="selected() as lead">
	<div class="rr-drawer-overlay" (click)="close()"></div>
	<aside class="rr-drawer">
		<div class="rr-drawer-hdr">
			<div>
				<div class="rr-drawer-name">{{ lead.name }}</div>
				<div class="rr-sub">{{ lead.company }} · #{{ lead.id }}</div>
			</div>
			<button class="rr-drawer-close" (click)="close()" title="Close">✕</button>
		</div>

		<div class="rr-drawer-body"> -->
	<!-- AI triage panel -->
	<!-- <div class="rr-panel rr-ai">
				<div class="rr-ai-head">
					<svg class="rr-ring rr-ring-lg" viewBox="0 0 40 40" width="58" height="58">
						<circle cx="20" cy="20" r="16" fill="none" stroke="#E2E8F0" stroke-width="4" />
						<circle cx="20" cy="20" r="16" fill="none" [attr.stroke]="band(lead.ai.score).color" stroke-width="4" stroke-linecap="round" [attr.stroke-dasharray]="ringDash(lead.ai.score)" transform="rotate(-90 20 20)" />
						<text x="20" y="24" text-anchor="middle" class="rr-ring-num" [attr.fill]="band(lead.ai.score).color">{{ lead.ai.score }}</text>
					</svg>
					<div>
						<div class="rr-panel-title">AI QC triage</div>
						<div class="rr-verdict" [style.color]="band(lead.ai.score).color">{{ verdict(lead) }}</div>
					</div>
				</div>
				<div class="rr-reasons">
					<div class="rr-reason" *ngFor="let r of lead.ai.reasons; trackBy: trackByReasonText"><span class="rr-dot" [style.background]="r.positive ? '#16A34A' : '#D97706'"></span>{{ r.text }}</div>
				</div>
				<div class="rr-flags" *ngIf="lead.ai.flags.length">
					<span class="rr-flag" *ngFor="let f of lead.ai.flags; trackBy: trackByValue">⚑ {{ f }}</span>
				</div>
			</div> -->

	<!-- Detail grid -->
	<!-- <div class="rr-grid">
				<div>
					<div class="rr-k">Campaign</div>
					<div class="rr-v">{{ lead.campaign }}</div>
				</div>
				<div>
					<div class="rr-k">Appointment</div>
					<div class="rr-v">{{ lead.apptDate }}, {{ lead.apptTime }}</div>
				</div>
				<div>
					<div class="rr-k">Meeting type</div>
					<div class="rr-v">{{ lead.meetType }}</div>
				</div>
				<div>
					<div class="rr-k">Warm-call</div>
					<div class="rr-v">{{ lead.apptConfirmed }}</div>
				</div>
			</div>
			<div class="rr-notes">
				<div class="rr-k">Caller notes</div>
				<div class="rr-v">{{ lead.notes }}</div>
			</div> -->

	<!-- Reserve guardrail -->
	<!-- <div class="rr-reserve" *ngIf="reserveInfo() as res" [class.exhausted]="res.exhausted" [class.low]="res.low">
				<div class="rr-reserve-title">
					<ng-container *ngIf="res.exhausted; else reserveLowTitle">⛔ Reserve exhausted</ng-container>
					<ng-template #reserveLowTitle>
						<ng-container *ngIf="res.low; else reserveDefaultTitle">⚠️ Reserve running low</ng-container>
					</ng-template>
					<ng-template #reserveDefaultTitle>💳 Prepaid reserve plan</ng-template>
				</div>
				<div class="rr-reserve-body">
					Lead <strong>#{{ res.position }} of {{ res.purchased }}</strong> · <strong>{{ res.remaining }}</strong> prepaid lead(s) remaining ({{ "$" + res.cpl }}/lead).
					<ng-container *ngIf="res.exhausted">Releasing as Reserve would give this lead away free — use <strong>Charge</strong> or log a replenishment.</ng-container>
					<ng-container *ngIf="!res.exhausted && res.low">Heads up — the prepaid block is almost used up.</ng-container>
				</div>
			</div> -->

	<!-- Billing select -->
	<!-- <div class="rr-billing">
				<div class="rr-k">Billing disposition</div>
				<select class="rr-select" [disabled]="!caps().releaseBilling" [value]="disposition()" (change)="disposition.set($any($event.target).value)">
					<option value="" disabled>Select disposition…</option>
					<option *ngFor="let d of dispositions; trackBy: trackByValue" [value]="d" [disabled]="d === 'reserve' && reserveDisabled()">{{ dispositionLabels[d] }}{{ d === "reserve" && reserveDisabled() ? " — exhausted" : "" }}</option>
				</select>
				<div class="rr-lock" *ngIf="!caps().releaseBilling">🔒 Your role ({{ ROLE_LABELS[perms.adminRole()] }}) can pass QC but not set billing. Releasing is a Super Admin action.</div>
			</div>
		</div> -->

	<!-- Fix reason (used by Send to Fix → returns the lead to the caller) -->
	<!-- <div class="rr-fix" *ngIf="lead.stage === 'review'">
			<label class="rr-k">Fix reason <span class="rr-fix-opt">(if sending back to caller)</span></label>
			<input class="rr-fixinput" [value]="fixReason()" (input)="fixReason.set($any($event.target).value)" placeholder="What the caller needs to correct…" />
		</div> -->

	<!-- Action bar (role + stage dependent) -->
	<!-- <div class="rr-actionbar">
			<ng-container *ngIf="lead.stage === 'review'; else billingActions">
				<button *ngIf="caps().releaseBilling; else passQcBtn" class="btn btn-p" [disabled]="!canRelease()" (click)="approveAndRelease()">Approve &amp; release</button>
				<ng-template #passQcBtn>
					<button class="btn btn-p" (click)="passQc()">Pass QC → billing</button>
				</ng-template>
				<button class="btn btn-o" (click)="sendToFix()">Send to Fix</button>
				<button class="btn btn-o rr-deny" (click)="deny()">Deny</button>
			</ng-container>
			<ng-template #billingActions>
				<button *ngIf="lead.stage === 'billing'" class="btn btn-p" [disabled]="!canRelease()" (click)="setBillingAndRelease()">Set billing &amp; release</button>
			</ng-template>
		</div> -->
	<!-- </aside>
</ng-container> -->

	<!-- Toast -->
	<!-- <div class="rr-toast" *ngIf="toast()">{{ toast() }}</div> -->
</div>
